import { Dispatchers_getInstanceitgtkvqfcnx3 as Dispatchers_getInstance } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Dispatchers.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { delay1diib1rb84y4j as delay } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import {
  ensureActivem48bojk66pw0 as ensureActive,
  CoroutineScopelux7s7zphw7e as CoroutineScope,
  CoroutineScopefcb5f5dwqcas as CoroutineScope_0,
} from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { SupervisorJobythnfxkr3jxc as SupervisorJob } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Supervisor.mjs';
import { AbstractCoroutineContextElement2rpehg0hv5szw as AbstractCoroutineContextElement } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContextImpl.mjs';
import { Key_instance2ye2t23iqghop as Key_instance } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineExceptionHandler.mjs';
import {
  Companion_getInstancec4l82qvpwbuq as Companion_getInstance,
  Reactive1jy75v4li6ldv as Reactive,
} from './coreInterfaces.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { Element2gr7ezmxqaln7 as Element } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContext.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { BaseListenable1u3g4s45l82o6 as BaseListenable } from './abstracts.mjs';
import { TypedReactiveContextwc1z7epz7cib as TypedReactiveContext } from '../context/ReactiveContext.mjs';
import { Duration5ynfiptaqcrg as Duration } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function remember(coroutineContext, useLastWhileLoading, deactivationDelay, action) {
  coroutineContext = coroutineContext === VOID ? Dispatchers_getInstance().wac_1 : coroutineContext;
  useLastWhileLoading = useLastWhileLoading === VOID ? false : useLastWhileLoading;
  deactivationDelay = deactivationDelay === VOID ? null : deactivationDelay;
  return Remember().hal(coroutineContext, useLastWhileLoading, deactivationDelay, action);
}
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  var tmp = $this.hao_1.ia3($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  $this.iao_1.aal_1.yai();
  var tmp_0 = $this.iao_1;
  tmp_0.cal_1 = $this.iao_1.aal_1.tah(() => {
    $this.iao_1.kal();
    return Unit_instance;
  });
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $this$launch, $completion) {
  var tmp = delay($this.jao_1.wak_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  ensureActive($this$launch);
  var tmp_0 = $this.jao_1;
  var tmp_1 = CoroutineScope($this.jao_1.vak_1);
  tmp_0.dal_1 = launch(tmp_1, VOID, VOID, Remember$deactivate$slambda$slambda_0($this.jao_1));
  $this.jao_1.bal_1 = null;
  return Unit_instance;
}
var Remember$deactivate$slambda$slambdaClass;
function Remember$deactivate$slambda$slambda() {
  if (Remember$deactivate$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.kao_1 = this$0;
      }
      wah($this$launch, $completion) {
        shutdown(this.kao_1);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope_0()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    Remember$deactivate$slambda$slambdaClass = $;
  }
  return Remember$deactivate$slambda$slambdaClass;
}
function Remember$deactivate$slambda$slambda_0(this$0) {
  var i = new (Remember$deactivate$slambda$slambda())(this$0);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function shutdown($this) {
  var tmp0_safe_receiver = $this.cal_1;
  if (tmp0_safe_receiver == null)
    null;
  else
    tmp0_safe_receiver();
  $this.cal_1 = null;
  $this.aal_1.lai();
  $this.yak_1.ma3();
  $this.yak_1 = SupervisorJob();
  $this.dal_1 = null;
}
var Remember$restOfContext$$inlined$CoroutineExceptionHandler$1Class;
function Remember$restOfContext$$inlined$CoroutineExceptionHandler$1() {
  if (Remember$restOfContext$$inlined$CoroutineExceptionHandler$1Class === VOID) {
    class $ extends AbstractCoroutineContextElement() {
      constructor() {
        super(Key_instance);
      }
      wa8(context, exception) {
        if (!(exception instanceof CancellationException())) {
          Companion_getInstance().xaj_1(exception);
        }
        return Unit_instance;
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [AbstractCoroutineContextElement(), Element()]);
    Remember$restOfContext$$inlined$CoroutineExceptionHandler$1Class = $;
  }
  return Remember$restOfContext$$inlined$CoroutineExceptionHandler$1Class;
}
var Remember$activate$slambdaClass;
function Remember$activate$slambda() {
  if (Remember$activate$slambdaClass === VOID) {
    class $ {
      constructor($it, this$0) {
        this.hao_1 = $it;
        this.iao_1 = this$0;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope_0()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    Remember$activate$slambdaClass = $;
  }
  return Remember$activate$slambdaClass;
}
function Remember$activate$slambda_0($it, this$0) {
  var i = new (Remember$activate$slambda())($it, this$0);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var Remember$deactivate$slambdaClass;
function Remember$deactivate$slambda() {
  if (Remember$deactivate$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.jao_1 = this$0;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope_0()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    Remember$deactivate$slambdaClass = $;
  }
  return Remember$deactivate$slambdaClass;
}
function Remember$deactivate$slambda_0(this$0) {
  var i = new (Remember$deactivate$slambda())(this$0);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var RememberClass;
function Remember() {
  if (RememberClass === VOID) {
    class $ extends BaseListenable() {
      static hal(incomingCoroutineContext, useLastWhileLoading, deactivationDelay, action) {
        incomingCoroutineContext = incomingCoroutineContext === VOID ? Dispatchers_getInstance().wac_1 : incomingCoroutineContext;
        useLastWhileLoading = useLastWhileLoading === VOID ? false : useLastWhileLoading;
        deactivationDelay = deactivationDelay === VOID ? null : deactivationDelay;
        var $this = this.sam();
        $this.vak_1 = incomingCoroutineContext;
        $this.wak_1 = deactivationDelay;
        $this.xak_1 = action;
        $this.yak_1 = SupervisorJob();
        var tmp = $this;
        // Inline function 'kotlinx.coroutines.CoroutineExceptionHandler' call
        var tmp$ret$0 = new (Remember$restOfContext$$inlined$CoroutineExceptionHandler$1())();
        tmp.zak_1 = $this.vak_1.gp(tmp$ret$0);
        $this.aal_1 = new (TypedReactiveContext())($this, useLastWhileLoading, VOID, $this.xak_1);
        $this.bal_1 = null;
        $this.cal_1 = null;
        $this.dal_1 = null;
        return $this;
      }
      ea2() {
        return this.yak_1.gp(this.zak_1);
      }
      qah() {
        if (!this.aal_1.vai_1) {
          this.aal_1.zai();
        }
        return this.aal_1.qah();
      }
      ial() {
        if (!(this.bal_1 == null)) {
          var tmp0_safe_receiver = this.bal_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.ma3();
          }
          this.bal_1 = null;
          return Unit_instance;
        }
        var tmp1_safe_receiver = this.dal_1;
        var tmp;
        if (tmp1_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          var tmp_0 = CoroutineScope(this.vak_1);
          tmp = launch(tmp_0, VOID, VOID, Remember$activate$slambda_0(tmp1_safe_receiver, this));
        }
        if (tmp == null) {
          // Inline function 'kotlin.run' call
          var $this$run = this;
          $this$run.aal_1.yai();
          var tmp_1 = $this$run;
          tmp_1.cal_1 = $this$run.aal_1.tah(() => {
            $this$run.kal();
            return Unit_instance;
          });
        }
      }
      jal() {
        var tmp = this.wak_1;
        if (!((tmp == null ? null : new (Duration())(tmp)) == null)) {
          if (!(this.bal_1 == null))
            return Unit_instance;
          var tmp_0 = this;
          tmp_0.bal_1 = launch(this, VOID, VOID, Remember$deactivate$slambda_0(this));
        } else {
          shutdown(this);
        }
      }
    }
    initMetadataForClass($, 'Remember', VOID, VOID, [Reactive(), CoroutineScope_0(), BaseListenable()]);
    RememberClass = $;
  }
  return RememberClass;
}
//region block: exports
export {
  Remember as Rememberkif8023snbmn,
  remember as remembery2gxxk5pa2qe,
};
//endregion

//# sourceMappingURL=Remember.mjs.map
